import React from 'react';
import { Box, Typography } from '@mui/material';

const NoResponses = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 250
      }}
    >
      <Typography variant="h5">No responses</Typography>
    </Box>
  );
}

export default NoResponses;
